import { render } from "./Historias.vue?vue&type=template&id=dcf1b4e6"
import script from "./Historias.vue?vue&type=script&lang=js"
export * from "./Historias.vue?vue&type=script&lang=js"

import "./Historias.vue?vue&type=style&index=0&id=dcf1b4e6&lang=css"
script.render = render

export default script